import { RadioGroup } from "@headlessui/react";
import { ShippingLabelType } from "../../../models/Shipping";
import classNames from "../../../utils/classNames";

interface ShippingLabelRadioProps {
  type: ShippingLabelType;
  setType: (type: ShippingLabelType) => void;
}

export default function ShippingLabelRadio({ type, setType }: ShippingLabelRadioProps) {
  const shippingLabelTypes = [
    { value: ShippingLabelType.S16      , label: "S16"  , image: "/shipping/s16.png" },
    // { value: ShippingLabelType.SixByFour, label: "6 x 4", },
    { value: ShippingLabelType.FourBySix, label: "4 x 6", image: "/shipping/4x6.png" },
  ];

  return (
    <RadioGroup
      value={type}
      onChange={setType}
      className="my-4"
    >
      <RadioGroup.Label className="sr-only">
        Choose a shipping label type
      </RadioGroup.Label>
      <div className="grid grid-cols-2 gap-3">
        {shippingLabelTypes.map((labelType) => (
          <RadioGroup.Option
            key={`${labelType.value}`}
            value={labelType.value}
            className={({ active, checked }) =>
              classNames(
                active
                  ? "ring-2 ring-offset-2 ring-slate-500"
                  : "",
                checked
                  ? "bg-gray-50 text-primary-600"
                  : "bg-white border-gray-200 text-gray-900 hover:bg-gray-50",
                "cursor-pointer focus:outline-none rounded-md py-1.5 px-3 flex items-center justify-center text-sm font-medium uppercase sm:flex-1"
              )
            }
          >
            <RadioGroup.Label as="span" className="space-y-4 flex flex-col items-center">
              {/* {type.label} */}
              <img src={labelType.image} alt={labelType.label} className="object-contain max-h-[167px]" />
              <div className={`w-6 h-6 transition-color duration-200 border-2 rounded-full flex items-center justify-center ${labelType.value === type ? 'border-primary-600' : 'border-gray-200'}`}>
                <div className={`w-3 h-3 transition-color duration-200 rounded-full ${labelType.value === type ? 'bg-primary-600' : 'bg-gray-100'}`}></div>
              </div>
            </RadioGroup.Label>
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
)
}